import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  userRoles: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getUserRoles = createAsyncThunk(
  'roles/userroles',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      let response = await axios({
        url: '/api/userRoles',
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const roleActive = createAsyncThunk(
  'user/role/reactive',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/userRoles/reActivate', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      //  console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const roleInActive = createAsyncThunk(
  'user/role/inactivate',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/userRoles/inActivate', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      //  console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const userRolesSlice = createSlice({
  name: 'userroles',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateRoles: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getUserRoles.fulfilled]: (state, { payload }) => {

      state.userRoles = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getUserRoles.pending]: (state) => {
      state.isFetching = true;
    },
    [getUserRoles.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateRoles } = userRolesSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateRoles());
  }
}

export const userRolesSelector = (state) => state.userroles;

export default userRolesSlice.reducer;
